import { render, staticRenderFns } from "./Cart_order.vue?vue&type=template&id=58bb3649&scoped=true"
import script from "./Cart_order.vue?vue&type=script&lang=js"
export * from "./Cart_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb3649",
  null
  
)

export default component.exports